import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import ShopColumnFourMain from "./ShopColumnFourMain";
import Footer from "../../components/Footer";
import ProductModal from "../../components/Modal/ProductModal";

const ShopColumnFour = () => {
  return (
    <>
      <ProductModal />

      <HeaderFour />

      <ShopColumnFourMain />

      <Footer />
    </>
  );
};

export default ShopColumnFour;
